import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names and resolves Tailwind conflicts, so a caller's prop can
 * always override a component's default:
 *
 * ```tsx
 * cn('px-3 py-1.5', className)   // className wins on any clashing utility
 * ```
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
